import { runAutoBootstrap } from "./auto-entry.js";

runAutoBootstrap().catch(() => {
  // swallow: loader has no signaling channel yet; loadConfigAndInject already console.warns on its own failures
});
